var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-between mb-8 space-x-4 w-full"},[_vm._t("default"),(_vm.title?.length)?_c('div',{staticClass:"text-2xl uppercase font-extrabold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"flex-1"}),_c('close-button',{staticClass:"pr-1",on:{"click":_vm.close}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }